/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import IconChangeData from '../../../assets/Images/icons/modalChangeData.svg';
import IconModalSync from '../../../assets/Images/icons/ModalSync.svg';
import { Modal, Button, Select, Form } from 'antd';
import { useTranslation } from 'react-i18next';

export default function ModalSync({
    form,
    open,
    handelClose,
    changeDataSource,
    item,
    dataSelection,
}) {
    const { Option } = Select;

    const { t } = useTranslation();
    const onSubmit = (value) => {
        const dataCatalog = dataSelection.filter(
            (res) => res?.dataCatalogId === value?.dataCatalogId
        );
        changeDataSource(item, dataCatalog[0]);
    };
    useEffect(() => {
        form.setFieldsValue({
            dataCatalogId: item?.sourceDataCatalogId,
        });
    }, [open]);
    return (
        <Modal
            width={540}
            className="_modal"
            afterClose={() => {
                form.resetFields();
                form.setFieldsValue({
                    dataCatalogId: item?.sourceDataCatalogId,
                });
            }}
            footer={false}
            open={open}
            onCancel={() => {
                handelClose();
                // form.resetFields();
            }}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-4 text-center">
                <div>
                    <img src={IconModalSync} alt="icon" />
                </div>
                <div className="text-1xl font-normal">
                    Change a data source catalog.
                </div>
            </div>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={onSubmit}
                initialValues={{ createInitail: 1 }}
            >
                <div className=" justify-center items-center py-2 px-4">
                    <div>
                        <div className="flex">
                            <div className="flex-auto w-[200px] h-[41px] p-[7px] bg-[#EDEEF9] border-solid border-[1px] rounded-md border-[#A9B2FF]">
                                <div className="flex items-center space-x-2">
                                    <svg
                                        width="12"
                                        height="13"
                                        viewBox="0 0 12 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="6"
                                            cy="6.5"
                                            r="6"
                                            fill="#4ACE8F"
                                        />
                                    </svg>
                                    <span className="font-semibold text-base line-clamp-1">
                                        {item?.datasetDataCatalogName}
                                    </span>
                                </div>
                            </div>
                            <div className="flex-auto p-1 w-[50px] text-center">
                                <img src={IconChangeData} alt="icon" />
                            </div>
                            <div className="w-[200px]">
                                <div className="flex items-center w-full">
                                    <Form.Item
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'this field is required.',
                                            },
                                        ]}
                                        name="dataCatalogId"
                                        className="w-full"
                                    >
                                        <Select
                                            placeholder="Select"
                                            size="large"
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            {dataSelection?.map((el) => (
                                                <Option
                                                    key={el?.dataCatalogId}
                                                    value={el?.dataCatalogId}
                                                >
                                                    {el?.dataCatalogName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center items-center py-4 space-x-4">
                    <Button
                        type="primary"
                        onClick={() => {
                            handelClose();
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Cancel')}
                    </Button>
                    <Button
                        // loading={loading}
                        htmlType="submit"
                        size="large"
                        type="primary"
                    >
                        {t('common.Confirm')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
}
